module.exports = __webpack_public_path__ + "static/media/2 (3).2e655a4b.jpg";